import { ZButton } from "@/shared/components/button";
import { ZModal, ZModalBody, ZModalContent, ZModalFooter, ZModalHeader } from "@/shared/components/modal";
import type { FC } from "react";

interface SubmitQuestionnaireModalProps {
  /**
   * Handler called when the user confirms to submit
   */
  onConfirm: () => void;

  /**
   * Handler called when the modal is closed without submitting
   */
  onClose: () => void;

  /**
   * Whether the modal is open or not
   */
  isOpen: boolean;

  /**
   * The title of the confirmation modal
   * @default "Submit Questionnaire?"
   */
  title?: string;

  /**
   * The primary message to display
   * @default "Once submitted, your responses are final and cannot be edited."
   */
  message?: string;

  /**
   * Whether the submit action is loading
   * @default false
   */
  isLoading?: boolean;
}

const SubmitQuestionnaireModal: FC<SubmitQuestionnaireModalProps> = ({
  onConfirm,
  onClose,
  isOpen,
  title = "Are you sure you want to submit?",
  message = "Once submitted, your responses are final and cannot be edited.",
  isLoading = false,
}) => {
  return (
    <ZModal
      isOpen={isOpen}
      onOpenChange={onClose}
    >
      <ZModalContent className="w-full max-w-[512px] shadow-[0px_0px_24px_rgba(0,0,0,0.05)] rounded-[16px]">
        <ZModalHeader className="flex text-[18px] font-semibold flex-col w-full items-center pb-0 text-[#11181C]">
          <p>{title}</p>
        </ZModalHeader>
        <ZModalBody className="pt-4 pb-2">
          <div className="flex flex-col items-center">
            <p className="text-[14px] text-[#777780] text-center mb-6">
              {message}
            </p>
          </div>
        </ZModalBody>
        <ZModalFooter className="justify-center gap-4 pt-2 pb-6">
          <ZButton
            variant="bordered"
            className="w-[226px] h-[40px] px-3 py-1 text-medium border-[#006FEE] text-[#006FEE]"
            onClick={onClose}
            disabled={isLoading}
          >
            Back
          </ZButton>
          <ZButton
            className="w-[226px] h-[40px] px-3 py-1 text-medium bg-[#006FEE] text-white"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Submit
          </ZButton>
        </ZModalFooter>
      </ZModalContent>
    </ZModal>
  );
};

export default SubmitQuestionnaireModal;
